import { LOGIN_ROUTE } from "@/routing/app-routes";
import composeRoute from "../routes/utils/route-utils/route-utils";
import {
  DISALLOWED_REDIRECTS,
  JWT_TOKEN,
  REDIRECT_KEY,
  SESSION_EXPIRED,
} from "./auth";

export const containsDisallowedRedirect = (url) => {
  return !DISALLOWED_REDIRECTS.every((dis) => !url.includes(dis));
};

export const storePushURL = () => {
  if (
    DISALLOWED_REDIRECTS.every((url) => !window.location.pathname.includes(url))
  ) {
    const redirectUrl = `${window.location.pathname}${window.location.hash}`;
    if (redirectUrl) {
      window.localStorage.setItem(REDIRECT_KEY, redirectUrl);
    }
  }
};

export const removePushURL = () => {
  window.localStorage.removeItem(REDIRECT_KEY);
};

export const getPushURL = () => {
  let redirectURL = window.localStorage.getItem(REDIRECT_KEY);
  if (redirectURL && containsDisallowedRedirect(redirectURL)) {
    redirectURL = undefined;
    removePushURL();
  }
  return redirectURL;
};

export const checkSession = (expiration, shouldRedirect = true) => {
  const exp = expiration * 1000;
  const time = new Date().getTime();
  if (shouldRedirect && expiration && exp < time) {
    localStorage.removeItem(JWT_TOKEN);
    storePushURL();
    window.location.href = composeRoute(
      LOGIN_ROUTE,
      [],
      [{ key: SESSION_EXPIRED, value: "1" }]
    );
    return false;
  }
  return true;
};
